import { useEffect } from 'react';
import FJImageManipulationLeftContainer from './FJImageManipulationLeft/FJImageManipulationLeftContainer';
import FJImageManipulationRightContainer from './FJImageManipulationRight/FJImageManipulationRightContainer';
import { useDispatch } from 'react-redux';
import FJActionImageManipulation from '../../redux/action/FJActionImageManipulation';

const FJImageManipulation = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        //初始化
        // document.title =
        //     FJConfig.appType === FJAppConstant.PHOTO_RESTORATION
        //         ? 'AI Old Photo Restoration | FlexClip'
        //         : 'AI Photo Colorizer | FlexClip';
        dispatch(FJActionImageManipulation.loadImageManipulationPageAction());
    }, []);

    return (
        <>
            <FJImageManipulationLeftContainer />
            <FJImageManipulationRightContainer />
        </>
    );
};

export default FJImageManipulation;
